<template>
	<div class="uk-width-1-1" :class="webinarItem.status === 'past' ? '' : 'dr-upcoming-webinar'">
        <div :class="webinarItem.status === 'past' ? 'dr-past-webinar uk-padding-bottom' : ''">
            
            <a :href="this.webinarItem.permalink" class="uk-card-small uk-card-hover uk-card-webinar uk-overflow-hidden">

                <div class="uk-width-expand uk-position-relative uk-flex uk-flex-column uk-flex-start" :class="webinarItem.status === 'past' ? 'uk-background-white' : 'uk-dark uk-card-body dr-upcoming-webinar-card'">

                    <div class="uk-width-expand">
                        <div class="uk-badge uk-overflow-ellipsis uk-badge-orange uk-margin-small-bottom" :class="webinarItem.status === 'past' ? 'uk-display-none ' : ''">{{ getWebinarTypeLabel() }}</div>

                        <div class="uk-flex uk-flex-middle">
                            <div class="uk-width-expand">
                                <time class="uk-card-webinar-label uk-text-uppercase uk-margin-2xsmall-bottom uk-text-muted uk-text-overline" 
                                      v-if="webinarItem.status === 'past'"
                                      :datetime="String(webinarItem.date)"
                                      :data-timestamp="webinarItem.date_gmt"
                                      data-format="F d, Y (l)"
                                      :title="titleAttribute">
                                      {{ visibleDateText }}
                                </time>


                                <div :class="webinarItem.status === 'past' ? '' : 'dr-upcoming-webinar-title'">
                                    <div class="uk-margin-remove-top uk-width-expand uk-webinar-title" :class="webinarItem.status === 'past' ? 'uk-padding-4xlarge-right uk-margin-remove-bottom uk-h6' : 'uk-margin-small-bottom uk-h4'" v-if="webinarItem.title" v-html="webinarItem.title"></div>
                                </div>
                            </div>

                            <div class="uk-badge uk-overflow-ellipsis uk-badge-white-light uk-border-remove uk-margin-remove" v-if="webinarItem.status === 'past'">{{ getWebinarTypeLabel() }}</div>
                        </div>

                        <div class="uk-flex uk-text-muted uk-text-small uk-text-font-default" v-if="webinarItem.location_name">
                            <span class="uk-icon uk-margin-xsmall-right uk-flex" uk-icon="icon: location;ratio:0.67"/>
                            <div>{{ webinarItem.location_name }}</div>
                        </div>
                    </div>

                    <time class="uk-margin-top uk-margin-auto-top dr-upcoming-webinar-date" 
                          :class="webinarItem.status === 'past' ? 'uk-display-none' : ''"
                          :datetime="String(webinarItem.date)"
                          :data-timestamp="webinarItem.date_gmt"
                          data-format="F d, Y (l)"
                          :title="titleAttribute">
                          {{ visibleDateText }}
                    </time>

                </div>
            </a>
            
        </div>
	</div>
</template>

<script>
    // Removed DateFormatter import, reverting to Day.js for localization

    export default {
        name: "Webinar-item",
		props: ['webinarItem', 'webinarItemType'],
		data() {
			return {
				locale: window.webinars_data.locale
			}
		},
		computed: {
            // Generates the value for the 'title' attribute using Day.js to mimic date.js but with localization
            // Uses *date_gmt* timestamp, converts to *local* time, formats as 'F d, Y (l)' equivalent
            titleAttribute() {
                if (!this.webinarItem || !this.webinarItem.date_gmt) return ''; // Use date_gmt 
                try {
                    // Create local time object from date_gmt timestamp
                    const localDate = this.$dayjs(this.webinarItem.date_gmt * 1000); 
                    // Format using Day.js equivalent of 'F d, Y (l)' with locale
                    return localDate.locale(this.locale).format('MMMM D, YYYY (dddd)');
                } catch (error) {
                    console.error('[WebinarItem] Error formatting title attribute using Day.js:', error);
                    return '';
                }
            },
            // Generates the visible date text using Day.js but with 'F d' format and localization
            // Uses *date_gmt* timestamp, converts to *local* time, formats as 'F d' equivalent
            visibleDateText() {
                if (!this.webinarItem || !this.webinarItem.date_gmt) return ''; // Use date_gmt
                try {
                    // Create local time object from date_gmt timestamp
                    const localDate = this.$dayjs(this.webinarItem.date_gmt * 1000); 
                    // Format using Day.js equivalent of 'F d' with locale
                    return localDate.locale(this.locale).format('MMMM D');
                } catch (error) {
                    console.error('[WebinarItem] Error formatting visible date text using Day.js:', error);
                    return '';
                }
            }
		},
		methods: {
            getWebinarTypeLabel() {
                // Determine webinar type based on status
                if (this.webinarItem.status === 'upcoming') {
                    return this.$t('webinars.upcoming_webinar');
                } else if (this.webinarItem.status === 'past') {
                    return this.$t('webinars.on_demand_webinar');
                }
                
                // If status is not defined, use type from props
                if (this.webinarItemType) {
                    return this.$t('webinars.' + this.webinarItemType);
                }
                
                // Fallback if nothing matches
                return this.$t('webinars.webinar');
            }
		}
	}
</script>

<style lang="scss">
    @import "assets/src/scss/misc/mixins";
    @import "assets/src/scss/uikit-theme/variables";

    .uk-card-webinar {
		display: flex;
		flex-direction: column;

		@include min(xs) {
			flex-direction: row-reverse;
		}

		.uk-card-webinar-image {
			padding-bottom: 50%;

			@include min(xs) {
				padding-bottom: 0;
			}
		}

		.uk-card-body {
			min-height: 350px;
			padding: 24px 24px 30px 24px;

			@include min(xs) {
				display: flex;
			}
		}

		.uk-card-webinar-label {
			@include min(xs) {
				position: static;
			}
		}
	}

    .dr-upcoming-webinar {
        min-height: 350px;
		background: $global-purple-color;
		transition: opacity 0.3s ease-in-out;

		&-date {
			position: relative;
			font-style: normal;
			font-weight: 400;
			text-transform: uppercase;
			padding-left: $global-small-margin;
			font-family: $global-monospace-font-family;
			font-size: $global-small-font-size;
			line-height: $global-line-height-12;
			letter-spacing: $global-letter-spacing-loose2;
			color: $global-black-color;

			&:after {
				background: #0b0b0b;
				content: "";
				position: absolute;
				margin: auto;
				left: 0;
				top: 0;
				bottom: 0;
				width: 10px;
				height: 5px;
				display: flex;
				justify-content: center;
				align-items: center;
			}
		}
	}

    .dr-past-webinar {
		border-bottom: 1px solid #e4e4e4;
	}

    .uk-webinar-title {
		line-height: 1.25;
	}
    
</style>
